module.exports = __webpack_public_path__ + "Roboto-Light-webfont.816d43bc217485bc52e3.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/assets/fonts/roboto/Roboto-Light-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Light-webfont.woff
// module chunks = styles